import React, { useCallback, useEffect, useState } from 'react';
import './css/index.scss';
import { useNavigate } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import IconButton from '../../components/IconButton';
import CancelEditingIcon from '../../assets/formIcons/cancelEditing.svg';
import Api from '../../Api';
import sendRequest from '../../helpers/sendRequest';
import SelectButton from '../../components/SelectButton';
import PersonalServiceSettings from './components/PersonalServiceSettings';
import OrganizationPromotionSettings from './components/OrganizationPromotionSettings';

const ACTIONS_TO_PAY_FOR = {
  donation: 'donation',
  personalService: 'personal_service',
  organizationPromotion: 'organization_promotion',
};

const ACTION_LABELS = {
  [ACTIONS_TO_PAY_FOR.personalService]: 'Персональная услуга',
  [ACTIONS_TO_PAY_FOR.organizationPromotion]: 'Продвижение организации',
};

const tempComponentStates = {
  actionType: 'actionType',
};

function PaymentSettings() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [tempComponentState, setTempComponentState] = useState(null);
  const [personalServiceData, setPersonalServiceData] = useState(null);
  const [organizationPromotionData, setOrganizationPromotionData] = useState(null);

  const onCancelClick = () => {
    navigate('/payments/view');
  };

  const fetchPersonalService = useCallback(async () => {
    const data = await sendRequest({
      request: Api.getPaymentSettings,
      payload: { action_to_pay_for: 'personal_service' },
      warnErrorText: 'while getting personal_service settings',
      setLoading,
    });
    if (data?.status === 'ok') {
      setPersonalServiceData(data);
    }
  }, []);

  const fetchOrganizationPromotion = useCallback(async () => {
    const data = await sendRequest({
      request: Api.getPaymentSettings,
      payload: { action_to_pay_for: 'organization_promotion' },
      warnErrorText: 'while getting organization_promotion settings',
      setLoading,
    });
    if (data?.status === 'ok') {
      setOrganizationPromotionData(data);
    }
  }, []);

  const handleActionSelect = (action) => {
    setSelectedAction(action);
    setTempComponentState(null);
    if (action === ACTIONS_TO_PAY_FOR.personalService) fetchPersonalService();
    if (action === ACTIONS_TO_PAY_FOR.organizationPromotion) fetchOrganizationPromotion();
  };

  useEffect(() => {
    if (selectedAction === ACTIONS_TO_PAY_FOR.personalService) fetchPersonalService();
    if (selectedAction === ACTIONS_TO_PAY_FOR.organizationPromotion) fetchOrganizationPromotion();
  }, [selectedAction, fetchPersonalService, fetchOrganizationPromotion]);

  return (
    <div className="payment_settings">
      <PageTitle
        text="Настройки платежей"
        RightComponent={(
          <IconButton
            svgPath={CancelEditingIcon}
            tooltipText="Отменить"
            onClick={onCancelClick}
          />
        )}
      />
      <div className="payment_settings_container">
        <div className="payment_settings_select_wrapper" style={{
          display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '400px',
        }}
        >
          <SelectButton
            label="Вариант платежа"
            value={selectedAction ? ACTION_LABELS[selectedAction] : ''}
            setTempComponentState={setTempComponentState}
            componentStateToSet={tempComponentStates.actionType}
            isActive={tempComponentState === tempComponentStates.actionType}
          />
        </div>

        {tempComponentState === tempComponentStates.actionType && (
          <div className="temp_container payment_settings_dropdown">
            <p className="temp_container_title">Выберите вариант платежа</p>
            <div className="temp_container_scroll">
              {Object.entries(ACTION_LABELS).map(([value, label]) => (
                <div
                  key={value}
                  className="temp_container_item"
                  onClick={() => handleActionSelect(value)}
                >
                  <p className="temp_container_item_text">{label}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {selectedAction === ACTIONS_TO_PAY_FOR.personalService && (
          <PersonalServiceSettings
            data={personalServiceData}
            loading={loading}
            onUpdate={fetchPersonalService}
          />
        )}

        {selectedAction === ACTIONS_TO_PAY_FOR.organizationPromotion && (
          <OrganizationPromotionSettings
            data={organizationPromotionData}
            loading={loading}
            onUpdate={fetchOrganizationPromotion}
          />
        )}
      </div>
    </div>
  );
}

export default PaymentSettings;
